import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy
} from '@angular/core';
import {TrelloChecklist} from 'projects/app-misc/src/app/modules/trello-misc/data/trello-checklist';
import {TrelloService} from 'projects/app-misc/src/app/modules/trello-misc/data/trello.service';
import {ProjectHolder} from 'projects/app-misc/src/app/modules/project-misc/interfaces/project-holder';
import {Project} from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import {environment} from 'projects/desktop/src/environments/environment';
import {ProjectWindowStore} from 'projects/app-misc/src/app/modules/project-misc/state/project-window.store';
import {User} from 'projects/core/src/lib/login/data/user';
import {timer, Subscription} from 'rxjs';
import {HttpEventType} from '@angular/common/http';
import {TrelloCheckItem} from '../../../trello-misc/data/trello-check-item';
import {MatSnackBarRef, SimpleSnackBar, MatSnackBar} from '@angular/material/snack-bar';
import {SelectItem} from 'primeng/api';

@Component({
  selector: 'app-add-punch-item',
  templateUrl: './add-punch-item.component.html',
  styleUrls: ['./add-punch-item.component.scss']
})
export class AddPunchItemComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  checkList: TrelloChecklist;

  checkItem: TrelloCheckItem;

  project: Project

  @Input()
  users: User[];

  @Input()
  tags = [];

  selectedTags: string[] = [];

  showInput = false;

  itemDescription: string;

  @Output() closeAction = new EventEmitter<void>();

  @Output() showLoadingSpinner = new EventEmitter<number>();

  @ViewChild('addPunchItemTextArea', {static: true})
  addPunchItemTextArea: ElementRef;

  loadingSpinner = false;

  files: File[] = [];

  activeSnackBar: MatSnackBarRef<SimpleSnackBar>

  ctrlEventListener = null;
  tempKey: any;

  timerSub: Subscription;

  filePasteListener = null;

  constructor(
    private snackBar: MatSnackBar,
    protected projectHolder: ProjectHolder,
    protected trelloService: TrelloService,
    protected elementRef: ElementRef,
    protected projectWindowStore: ProjectWindowStore
  ) {
    this.project = this.projectHolder.project

    this.checkItem = {
      id: null,
      files: []
    }
  }

  ngOnInit() {
    this.subToCTRLEnter();

    this.filePasteListener = (event: ClipboardEvent) => {
      this.onFilePaste(event)
    }
  }

  subToCTRLEnter() {
    this.ctrlEventListener = (event: KeyboardEvent) => {
      this.ctrlEnterEvent(event)
    }

    document.addEventListener('keydown', this.ctrlEventListener);
  }

  ctrlEnterEvent(event) {
    const key = (event as KeyboardEvent).key; // const {key} = event; in ES6+

    if (this.tempKey === 'Control') {
      if (key === 'Enter') {
        this.addItem();
      }
    }
    this.tempKey = key;

    if (!this.timerSub) {
      this.timerSub = timer(500).subscribe(() => {
        this.tempKey = null;
        this.timerSub = null;
      })
    }
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.ctrlEventListener);
  }

  ngAfterViewInit() {
    (this.addPunchItemTextArea.nativeElement as HTMLElement).focus();
  }

  showInputItem() {
    this.showInput = true;
    this.closeAction.emit();
  }

  addItem() {
    if (typeof this.checkList === 'undefined') {
      this.trelloService.createChecklist(this.project.card.id, {
        id: null,
        name: environment.trelloPunchCheckListName
      }).subscribe(checkList => {
        this.project.card.checklists.push(checkList)
        this.projectWindowStore.updatePunchListId(checkList.id)
        this.checkList = checkList

        if (!(this.checkList.checkItems instanceof Array)) {
          this.checkList.checkItems = []
        }
        this.addCheckItem()
      })
    } else {
      this.addCheckItem()
    }
  }

  addCheckItem() {
    this.loadingSpinner = true;

    const cItem = {
      id: null,
      name: this.itemDescription,
      tagTypes: this.selectedTags,
      ready: false
    } as TrelloCheckItem

    if (this.selectedTags.includes('Amount')) {
      cItem.amount = this.checkItem.changeOrderAmount
    }

    this.trelloService
      .createCheckItem(
        this.checkList.id, cItem).subscribe(checkitem => {

      const existingItem = this.checkList.checkItems.find(fCheckitem => fCheckitem.id === checkitem.id)

      if (!existingItem) {

        const checkItem = {
          id: checkitem.id,
          name: checkitem.name,
          tags: checkitem.tags,
          mentions: checkitem.mentions,
          ready: false
        } as TrelloCheckItem

        this.checkList.checkItems.push(checkItem)
      } else if (this.tags) {
        existingItem.tags = checkitem.tags
      }

      if (this.files.length > 0) {
        const fCheckItem = this.checkList.checkItems.find(fCheckitem => fCheckitem.id === checkitem.id)

        this.trelloService.checkItemLoading$.next(checkitem.id)

        this.trelloService.uploadFile(this.files, checkitem.id).subscribe(httpEvent => {

          if (httpEvent.type === HttpEventType.Response) {
            this.trelloService.checkItemLoading$.next(-1)

            fCheckItem.files = httpEvent.body;

            this.checkList.checkItems = [...this.checkList.checkItems]

            this.itemDescription = ''
            this.loadingSpinner = false;
            this.checkItem.files = [];

          }
        }, error => {
          this.loadingSpinner = false
          this.openSnackBar(error.message)
        })
      } else {

        this.checkList.checkItems = [...this.checkList.checkItems]

        this.itemDescription = ''
        this.loadingSpinner = false;
        this.closeAction.emit();

      }
      this.closeAction.emit();
      this.showInput = false;

    }, error => {
      this.loadingSpinner = false;
      this.openSnackBar(error.message)
    })
  }

  hideInputItem() {
    this.showInput = false;
    this.itemDescription = '';
    this.checkItem.files = [];
    this.closeAction.emit();
  }

  uploadFile(files: File[], filesForm?) {
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < files.length; i++) {
      this.files.push(files[i])
      this.checkItem.files.push({
        id: null,
        name: files[i].name
      })
    }

    if (filesForm) {
      filesForm.clear();
    }
  }

  deleteFile(file: File) {
    const index = this.files.indexOf(file, 0);
    if (index > -1) {
      this.files.splice(index, 1);
    }
  }

  openSnackBar(message: string, duration = 5000) {
    if (this.activeSnackBar) {
      this.activeSnackBar.dismiss();
    }

    this.activeSnackBar = this.snackBar.open(message, '', {
      duration,
      panelClass: 'error-snackbar',
      verticalPosition: 'top',
    });
  }

  tagChanged(tags: SelectItem[]) {
    this.selectedTags = tags.map(tag => tag.value.name);
  }

  onFilePaste(event: ClipboardEvent) {
    const items = (event.clipboardData).items;
    // tslint:disable-next-line: forin
    for (const index in items) {
      const item = items[index];
      if (item.kind === 'file') {
        const file = item.getAsFile();

        this.uploadFile([file])
      }
    }
  }

  onMentionSelect(user: User) {
    return '@' + user.username + ' ';
  }
}
